// ✅ FileIcon.jsx
import React from "react";

// Map extensions to their corresponding public/assets icon
const iconMap = {
  pdf: "/assets/pdf.png",
  doc: "/assets/word.png",
  docx: "/assets/word.png",
  xls: "/assets/excel.png",
  xlsx: "/assets/excel.png",
  csv: "/assets/csv.png",
  txt: "/assets/txt.png",
  jpg: "/assets/jpg.png",
  jpeg: "/assets/jpg.png",
  png: "/assets/png.png",
  webp: "/assets/webp.png",
  default: "/assets/file.png", // fallback icon
};

const FileIcon = ({ fileName, size = 40, alt = "File" }) => {
  if (!fileName || typeof fileName !== "string") {
    return <img src={iconMap.default} alt={alt} width={size} height={size} />;
  }

  const ext = fileName.split(".").pop().toLowerCase();
  const iconSrc = iconMap[ext] || iconMap.default;

  return <img src={iconSrc} alt={alt} width={size} height={size} />;
};

export default FileIcon;
